module.exports = __webpack_public_path__ + "static/media/background.c64d332a.jpg";